import { getCdnImage } from './ImageManager'

export default (imageUrl, originalImgWidth, minWidth) => {
  let fluidSizes = [400, 600, 800, 1200, 1400, 1600],
    imageSrcSet = [];

  let filteredSizes = fluidSizes.filter(size => size <= originalImgWidth);

  if (minWidth) {
    filteredSizes = fluidSizes.filter(size => size >= minWidth);
  }

  //If the cloudinary enabled flag set to false it will return the cdn link from contentful
  //image size will be defined by the size param in getCdnSrcset function
    filteredSizes.map(imgSize => {
      imageSrcSet.push(`${getCdnImage(imageUrl, { w: imgSize })} ${imgSize}w`);
    });

    return imageSrcSet.join(',');

};
